import React from "react";
import { useSelector } from "react-redux";
import { Flex } from "@cisco/spaces-dash-lib-styleguide";
import { ToastCard } from "../components/ToastCard";

function Toasts({ autoCloseTimeout }) {
  const { toasts = [] } = useSelector((state) => state.toasts);

  return (
    <div className="lib-notification-toast-container">
      <Flex align="flex-end" direction="vertical" gap={8}>
        {toasts.map((t) => (
          <ToastCard key={t.id} toast={t} autoCloseTimeout={autoCloseTimeout} />
        ))}
      </Flex>
    </div>
  );
}

export default Toasts;
